module.exports = __webpack_public_path__ + "assets/aeed8ee9154f5844acb55fed4929b499.mp3";